import { mapGetters } from 'vuex';
import employService from '@/services/employ';
import Utils from "@/mixins/Utils";
import jobofferService from "../../services/jobOffer";
import _ from "lodash";

export default {
  data() {
    return {
      rows: 100,
      perPage: 10,
      currentPage: 1,
      missions: [],
      limit: 5
    }
  },
  mixins: [Utils],
  computed: {
    listCandidatures() {
      return _.orderBy(this.missions, ['applicationInfo.applicationDate'], ['desc']).slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    ...mapGetters({
      spinnerCandidature: 'isLoading'
    }),
  },

  mounted() {
    this.myApplications();
  },

  methods: {
    myApplications() {
      // employService.getMyApplications()
      jobofferService.getCandidatures()
      .then(res => {
        this.missions = res.data.records;
      }).catch(() => {
        this.callToaster(this.$t('problem-arise'))
      })
    },
    annulerOffre(idCandidature, idJobOffer) {
      jobofferService.deleteCandidature(idCandidature).then(res => {
        if (res.success) {
          this.callToaster(this.$t('cancel-candidature-success'));
          this.missions = this.missions.filter(m => m.pkJobOffer != idJobOffer);
        } else {
          this.callToaster(res.message || this.$t('problem-arise'));
        }
      }).catch(err => {
        this.callToaster(this.$t('problem-arise'));
      })
    },
  },
};